import React, {
  useContext,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";
import Button from "components/button/button";
import { FaEllipsisH } from "react-icons/fa";
import { IoEllipse } from "react-icons/io5";
import { BsGlobe2, BsExclamationDiamondFill } from "react-icons/bs";
import { embedVideo } from "utils/constant";
import UserTagIconSVG from "assets/svg/user-tag-icon";
import { Context } from "context/context";
import { formatDate, isImgUrl, removePostalCode, currentLang, toTitleCase } from "utils/utils";
import ReactPlayer from "react-player";
import _ from "lodash";
import Popup from "reactjs-popup";
import OptionListItem from "../more-option/option-list-item";
import { gsap } from "gsap";
import AudioPlayer from "../media-button/audio-player";
import LazyImage from "../LazyImage";
// import { imageSquareOrPortrait } from "utils/utils";
import PrivacyBadge from "components/milestonelist/privacyBadge";
import { AiFillPushpin } from "react-icons/ai";
import { imageSquareOrPortrait, profileTag } from "utils/utils";
import CharacterLimit from "../character-limit";
import ToolTip from "components/tootltip/tootltip";
import { CoverPlaceholderMilestone } from "constants/images";
import { DetailedViewCard as MainDetailedViewCard, scrollToElementWithOffset } from "../detailed-view";
import { useWindowDimensions } from "utils/customhooks";
import MediaButton from "components/button/media-button";
import { useMilestones } from "redux/modules/milestone/hooks";
import { JOB_ROLE, CATEGORY } from "constants/options";
import Collapsible from "components/collapsible";
import { useTranslation } from "react-i18next";
import { useDialogHook } from "utils/customhooks";
import PinnedReorder from "../pinned-reorder";
import { CgArrowsExchangeV } from "react-icons/cg";
import { useLocation, useHistory } from 'react-router-dom';
import DetailedViewEdit from "../quick-edit/detailed-view-edit";

export const DetailedViewCard = ({
  title,
  dateNote,
  date,
  people,
  url = "",
  viewUrl = "",
  description,
  privacy,
  isAdultContent,
  category,
  buttons = [],
  position,
  positionDescription,
  positions = [], //for Category
  platform,
  isYourProfile,
  permission,
  profile,
  featured,
  containerStyle = "",
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onReport = () => {},
  tagView = false,
  onRemoveTag = () => {},
  activePopup = {},
  handlePopup = () => {},
  indexPopUp = -1,
  group = null,
  location,
  setActivePopup = () => ({ group: null, index: null }),
  mention_names = {},
  isPinned = false,
  dataId,
  categories=[],
  onShare = ()=>{},
  share,
  milestone_owner,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  setQuickEditId,
  quickEditId,
  cancelEdit,
  userData,
  updateMilestonesState,
  milestoneEmbed = () => {},

}) => {
  const {t} = useTranslation();
  const {translation = {}} = featured;
  const { showMaturedContent, setShowMaturedContent } = useContext(Context);
  const [showMoreOption, setShowMoreOption] = useState();
  const [showAllMedia, setShowAllMedia] = useState(false);
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [imageHeight, setImageHeight] = useState(null);
  // const [customClass, setCustomClass] = useState("");
  const [hideMusic, setHideMusic] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [showIndPlayer, setShowIndPlayer] = useState(null);
  const [isVisible, setIsVisible] = useState(-1);
  const [desc, setDescription] = useState(() => {
      const lang = currentLang();
      const t = translation?.[lang];
      return t?.description || description;
    });
  const listenRef = useRef();
  const optionRef = useRef();
  const contentRef = useRef();
  const { http } = global.services;
  const { isMobile } = useWindowDimensions();
  const { setPLayMusic, organizeBy } = useMilestones();

  const loc = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!_.isEmpty(mention_names)) {
      let newDesc = profileTag(mention_names, description);
      setDescription(newDesc);
    }
    setDescription(() => {
        const lang = currentLang();
        const t = translation?.[lang];
        return t?.description || description;
      }); 
  }, [description, mention_names,translation]);

  useEffect(() => {
      const search = new URLSearchParams(loc.search);
      const focusMiletone = search.get("focusMilestone");
      if(focusMiletone) {
        const targetId = Number(focusMiletone);
        const currentId = Number(dataId);
        if(targetId === currentId) {
          const element = document.querySelector(`[data-milestone-id="${targetId}"]`);
          // element.scrollIntoView();
          scrollToElementWithOffset(element, 120); // scroll with 50px top space
          const pathWithoutSearch = loc.pathname;
          history.replace(pathWithoutSearch);
        }
      }
    }, [loc, dataId, history]);

  const handleMedia = async (media) => {
    http.post(`button-click/`, { id: media.id });
    let orientation = "Landscape";
    let url = "";
    let fileExt = "";

    if (
      media.sub_type.name === "Multiple Images" ||
      media.sub_type.name === "Single Image"
    ) {
      onViewImage(title, media, media["media"]);
    } else {
      if (media.url) {
        url = media.url;
        orientation = media?.orientation;
      } else {
        url = media["media"][0]["media"]["url"];
        orientation = media["media"][0]["media"]["orientation"];
        fileExt = media["media"][0]["media"]["file_extension"];
      }

      if (await isImgUrl(url)) {
        onViewImage(title, media, media["media"]);
      } else if (ReactPlayer.canPlay(url)) {
        onWatchMedia(title, url, orientation);
      } else if (fileExt === "pdf") {
        handleViewPdf(title, url,media["media"], media);
      } else {
        if (embedVideo.find((v) => url.includes(v.value)) || ReactPlayer.canPlay(url)) {
          onWatchMedia(title, url, orientation);
        } else {
          window.open(url, "_blank");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        if (listenRef.current) {
          setHideMusic(true);
        }
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, []);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-item",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  useEffect(() => {
    (async () => {
      const res = await imageSquareOrPortrait(url);
      const element = contentRef.current;
      if (res === "portrait") {
        if (element) {
          if (element.offsetHeight < 300) {
            setImageHeight(300);
          } else {
            setImageHeight(element.offsetHeight);
          }
          setImageUrl(url);
        }
      } else {
        setImageUrl(url);
      }
    })();
  }, [url]);

  return (
    // <div
    // className={`milestone-item w-full bg-siteBg 2md:rounded-md overflow-hidden ${containerStyle}`}>
    <div className="milestone-item w-full bg-siteBg rounded-md mt-0 2sm:mt-4.5 3md:mt-6" data-milestone-id={dataId || "no-id"}>
      {
        featured.id === quickEditId ?
          <DetailedViewEdit
            buttons={buttons}
            title={title}
            description={description}
            positions={positions}
            milestone={featured} 
            date={date}
            profile={profile}
            cancelEdit={cancelEdit}
            url = {url}
            viewUrl = {viewUrl}
            userData={userData}
            updateMilestonesState={updateMilestonesState}
            group={group}
            platform={platform}
            location={location}
        /> :
          <div
            className={`w-full flex flex-col 2md:flex-row space-y-0.5 2md:space-x-0.5 2md:space-y-0  ${
              imageUrl ? "min-h-300" : "min-h-300"
            }`}
          >
            {/* image */}
            {imageUrl ? (
              <div className="relative bg-white h-auto 2md:min-h-[300px] 2md:w-[300px]">
                {/* thumbnail */}
                <LazyImage
                  viewUrl={viewUrl}
                  source={imageUrl}
                  customClassName="w-full md:max-w-[300px] h-auto 2md:max-h-[300px]"
                  imageHeight={imageHeight}
                  withContainer="w-full 2md:w-[300px]"
                />
                {/* restricted Image */}
                {/* {!isAdultContent && !showMaturedContent && (
                  <div className="absolute top-0 left-0 matured-content-blured">
                    <div className="w-full px-6 text-center">
                      <div className="flex justify-center">
                        <BsExclamationDiamondFill className="text-5xl" />
                      </div>
                      <h3 className="mt-4.5 font-bold text-lg">Mature Content</h3>
                      <p className="mt-4 text-sm font-medium hidden sm:block">
                        You must be 18+ to view this image. Are you over eighteen
                        and willing to see adult content?
                      </p>
                      <Button
                        buttonName="Continue"
                        buttonTextClass="text-sm text-white font-semibold"
                        buttonRadius="6px"
                        buttonClass="relative py-4 px-11 bg-transparent border-2 border-white mt-5.5"
                        onClick={() => setShowMaturedContent((prev) => !prev)}
                      />
                    </div>
                  </div>
                )} */}
              </div>
            ) : (
              <div className="relative min-h-[300px] 2md:w-[300px] flex items-center justify-center bg-[#e9e9e9]">
                <div className="w-full 2md:w-[300px] flex items-center justify-center h-full bg-[#e9e9e9]">
                  <img
                    src={CoverPlaceholderMilestone}
                    alt="Milestone"
                    className="h-[111px] w-[113px]"
                  />
                </div>
              </div>
            )}
            {/* content container */}
            <div
              className={`relative bg-white 2md:mt-0 px-6 pb-6 pt-4 2sm:py-4 2sm:px-7.5 p-7 w-full ${
                url
                  ? "width-responsive-detailed-view"
                  : "width-responsive-detailed-view-full"
              }`}
              ref={contentRef}
            >
              {/* <div className="w-full flex 1sm:hidden justify-end">
                <button className="bg-thBg w-10 h-10 rounded-md">
                  <FaEllipsisH className="m-auto" />
                </button>
              </div> */}
              {/* content */}
              <div className="w-full flex justify-between h-full">
                <div className="flex items-center w-full h-full">
                  <div className="w-full">
                    {/* title */}
                    <div className="flex items-center space-x-5 flex-wrap">
                      <p className="text-base 2sm:text-xl 3md:text-2xl text-lightBlack font-medium tracking-tighter leading-5 2sm:leading-7">
                        {toTitleCase(translation?.[currentLang()]?.[title] || title)}
                      </p>
                    </div>
                    {/* category */}
                    {/* <div className="flex items-center space-x-5 flex-wrap">
                    <p className="px-4.5 py-1.5 bg-lightGreen text-white text-xs uppercase font-semibold rounded-md">
                      {category}
                    </p>
                  </div> */}
                    {/* details */}
                    <div className="w-full mt-0 2sm:mt-1.5">
                      <div className="w-full text-[11px] 2sm:text-sm 3md:text-base text-darkerGray font-medium 3md:leading-[16px] inline-flex items-center flex-wrap gap-x-3 gap-y-1">
                        <div className="item-col-lg">
                          <p>
                            {date}
                            {dateNote && (
                              <span className="ml-1">{`(${translation?.[currentLang()]?.[dateNote] || dateNote})`}</span>
                            )}
                          </p>
                        </div>
                        {
                          isYourProfile && 
                          <div className="item-col-lg">
                            <PrivacyBadge
                              privacy={privacy}
                              isYourProfile={isYourProfile}
                            />
                          </div>
                        }

                        {isAdultContent && (
                          <div className="item-col-lg">
                            <span className="text-red flex flex-row items-center font-medium">
                              <BsExclamationDiamondFill className="mr-1.5" /> 
                              {t('adultContent')}
                            </span>
                          </div>
                        )}
                        {/* <p className="flex items-center capitalize">
                        {privacy === "public" ? (
                          <BsGlobe2 className="mr-1.5" />
                        ) : (
                          <BsExclamationDiamondFill className="mr-1.5" />
                        )}
                        {privacy}
                      </p> */}
                        {people && (
                          <div className="item-col-lg">
                            {/* <p className="hidden md:block">
                              <IoEllipse className="w-1 h-1" />
                            </p> */}
                            <p className="hidden md:flex items-center">
                              <UserTagIconSVG className="mr-1.5" />
                              {people}
                            </p>
                          </div>
                        )}
                        {
                        (isPinned || organizeBy === JOB_ROLE) ? ( 
                          <>
                            <>
                                {
                                  categories.map((item,index)=>{
                                    return(
                                        <p key={index} className="px-1.5 py-1 block 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                                          {(!profile?.dateFormat && item[currentLang()] === 'Theatre') ? 'Theater' : item[currentLang()] ||item.name}
                                        </p>
                                    )
                                  })
                                }
                              </>  
                            {/* <div className="inline-flex flex-wrap 2sm:hidden gap-2">
                              {
                                categories.map((item,index)=>{
                                  return( 
                                    <p key={index.name} className="px-1.5 py-1 block  3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                                    {item[currentLang()] ||item.name}
                                    </p> 
                                  )
                                })
                              }
                            </div>  */}
                          </>
                        ):
                        (
                          <>
                          <div className="item-col-lg">
                            <p
                              className="hidden 2sm:inline px-1.5 py-1 block  3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md "
                              style={{ marginLeft: 0 }}
                            >
                              {category}
                            </p>
                          </div>
                          <p className="inline 2sm:hidden px-1.5 py-1 block  3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                            {category}
                          </p>
                          </>
                        )
                      }
                      </div> 
                      
                    </div>
                    {/* Author Name and description */}
                    <div className="w-full my-0 mt-1 ">
                      {(isPinned || organizeBy === CATEGORY) ? (
                        <p className="text-[13px] 2sm:text-sm 3md:text-base font-bold 3md:leading-6 mt-0 2sm:mt-1.5">
                          {/* {positions.map((p, i) => (
                          <span key={i}>
                            {p.position.name}
                            {p.description && ` - ${removePostalCode(p.description)}`}
                            {i < positions.length - 1 && ", "}
                          </span>
                        ))} */}
                          <span>
                            {positions
                              .map((p) => {
                                const _pos = [p.position[currentLang()]?.trim() || p.position.name?.trim()];
                                if (p.description)
                                  _pos.push(removePostalCode(p.description).trim());
                                return _pos.join(" - ");
                              })
                              .join(", ")
                              .trim()}
                          </span>
                          <span className="break-anywhere">
                            {platform &&
                              ` (${platform}${location ? ` - ${location}` : ""})`}
                          </span>
                        </p>
                      ) : (
                        <p className="text-[13px] 2sm:text-sm 3md:text-base font-bold 3md:leading-6 mt-0 2sm:mt-1.5">
                          {position}
                          {positionDescription &&
                            ` - ${removePostalCode(positionDescription)}`}
                          {platform && 
                          ` (${translation?.[currentLang()]?.[platform] || platform}
                                ${location ? ` - ${translation?.[currentLang()]?.[location] || location}` : ""})`}
                        </p>
                      )}
                      {/* <p
                      className="mt-2.5 text-base leading-7.5 tracking-tightest truncate-multiline"
                      dangerouslySetInnerHTML={{ __html: description }}></p> */}
                      <CharacterLimit html={desc} />
                    </div>
                    {/* buttons */}
                    {!_.isEmpty(buttons) && (
                      <div className="w-full mt-3 flex flex-col md:grid md:grid-cols-[1fr] gap-3">
                        <div className="w-full flex flex-col md:grid md:grid-cols-[repeat(3,1fr)_90px] gap-3">
                          {buttons
                            .slice(
                              0,
                              showAllMedia ? buttons.length : !isMobile ? 3 : 2
                            )
                            .map((btn, index) => {
                              if (btn.type.name === "Listen") {
                                return (
                                  <div
                                    className="relative"
                                    style={{ gridColumn: (index % 3) + 1 }}
                                  >
                                    <MediaButton
                                      key={index}
                                      buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                                      buttonData={btn}
                                      buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                      buttonRadius="6px"
                                      buttonClass={`relative rounded-md py-3 px-4 xl:px-0 border-2 border-gray bg-white hover:bg-thBg w-full h-full`}
                                      onClick={() => {
                                        setPLayMusic(btn);
                                        handlePopup();
                                        setIsVisible(buttons.id);
                                        setShowAudioPlayer((prev) => !prev);
                                        setShowIndPlayer(btn.id);
                                      }}
                                    />
                                    {activePopup.group === group &&
                                      activePopup.index === indexPopUp &&
                                      btn.id === showIndPlayer && (
                                        <div
                                          className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                          ref={listenRef}
                                        >
                                          <AudioPlayer
                                            media={btn}
                                            hide={hideMusic}
                                            onClosePlayer={() => {
                                              setActivePopup({
                                                group: null,
                                                index: null,
                                              });
                                              setShowIndPlayer(null);
                                            }}
                                          />
                                        </div>
                                      )}
                                    {(organizeBy === JOB_ROLE ||
                                      organizeBy === CATEGORY) &&
                                      btn.id === showIndPlayer && (
                                        <div
                                          className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                          ref={listenRef}
                                        >
                                          <AudioPlayer
                                            media={btn}
                                            hide={hideMusic}
                                            onClosePlayer={() => {
                                              setIsVisible(null);
                                              setShowIndPlayer(null);
                                            }}
                                          />
                                        </div>
                                      )}
                                  </div>
                                );
                              }
                              return (
                                <div style={{ gridColumn: (index % 3) + 1 }}>
                                  <MediaButton
                                    buttonData={btn}
                                    key={index}
                                    buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                                    buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                    buttonRadius="6px"
                                    buttonClass="relative rounded-md py-3 px-4   xl:px-0 border-2 border-gray bg-white bg-white hover:bg-thBg w-full h-full"
                                    onClick={() => handleMedia(btn)}
                                  />
                                </div>
                              );
                            })}
                          {buttons.length > (!isMobile ? 3 : 2) && (
                            <button
                              className={`rounded-md  col-start-4 row-start-1 row-span-1 ${
                                showAllMedia
                                  ? "bg-lightBlack text-white"
                                  : "bg-thBg"
                              }`}
                              onClick={() => setShowAllMedia(!showAllMedia)}
                            >
                              {showAllMedia ? "Hide" : `+${buttons.length - (!isMobile ? 3 : 2)}`}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* more */}
                <Popup
                  ref={optionRef}
                  position="bottom right"
                  open={showMoreOption}
                  onClose={() => setShowMoreOption(false)}
                  arrow={false}
                  contentStyle={{ marginTop: 10, marginLeft: 5 }}
                  trigger={
                    <button
                      // className="bg-thBg w-10 h-10 rounded-md hidden 1sm:block"
                      className="bg-thBg w-6 h-6 2sm:w-10 2sm:h-10 rounded-md inline"
                      onClick={() => setShowMoreOption((open) => !open)}
                    >
                      <FaEllipsisH className="m-auto text-1xs md:text-base" />
                    </button>
                  }
                >
                  <OptionListItem
                    {...{
                      isYourProfile,
                      onEdit,
                      onDelete,
                      permission,
                      onReport,
                      profile,
                      featured,
                      onShare,
                      share,
                      onCopyLink,
                      setQuickEditId,
                      isMobile,
                      milestoneEmbed,
                      tagView,
                      onRemoveTag
                    }}
                    closeMoreOption={() => {
                        setShowMoreOption(false);
                        optionRef.current.close();
                      }}
                    title={translation?.[currentLang()]?.[title] || title}
                    detailedView={true}
                  />
                </Popup>
              </div>
            </div>
          </div>
      }
    </div>
  );
};

export default function OrganizePositionDetailedView({
  featured = {},
  milestones = [],
  pin = [],
  showFeatured,
  isYourProfile,
  profile,
  onWatchMedia = () => {},
  onViewImage = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onReport = () => {},
  organizeBy,
  positions = [],
  categories = [],
  onShare = ()=>{},
  milestone_owner,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  userData={},
  updateMilestonesState,
  milestoneEmbed = () => {},
}) {
  const {t} = useTranslation();
  const pinnedOrder =useDialogHook(PinnedReorder)
  const milestoneKeys = Object.keys(milestones);
  const [quickEditId, setQuickEditId] = useState(null);
  const featuredThumbnail = featured.thumbnail
    ? featured.thumbnail.webp_url || featured.thumbnail.url
    : null;

  useLayoutEffect(() => {
    gsap.fromTo(
      ".organize-title",
      {
        y: -20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  const customHandle = ()=>{ 
    pinnedOrder({milestones:pin,profile},(callback)=>{
      if(callback?.success){
        return;
      }
    })
  }

  const findJobOrCat = (key) =>{
    return (organizeBy === JOB_ROLE ? positions : categories)
            .find((item) => item.name === key);
  }

  return (
    <div className="w-full container-max-width px-4 3md:px-0">
      {showFeatured && (
        <div className="w-full container-max-width mb-2">
          {!_.isEmpty(featured) && (
            <DetailedViewCard
              profile={profile}
              featured={featured}
              url={featuredThumbnail}
              viewUrl={featuredThumbnail || featured?.thumbnail?.url || null}
              title={featured.title}
              date={featured.formatted_date}
              people={featured.people}
              position={featured[currentLang()] || featured.name}
              positionDescription={featured.mp_description}
              platform={featured.platform}
              description={featured.description}
              privacy={featured.privacy}
              isAdultContent={featured.is_adult_content ? true : false}
              category={featured.category && (featured.category[currentLang()] || featured.category.name)}
              buttons={featured.media_type}
              onWatchMedia={onWatchMedia}
              onViewImage={onViewImage}
              onEdit={() => onEdit(featured, "featured")}
              onDelete={() => onDelete(featured)}
              isYourProfile={isYourProfile}
              onReport={() => onReport({...featured, profile:milestone_owner})}
              location={featured.location}
              positions={featured.positions}
              milestoneEmbed={() => milestoneEmbed(featured)}
            />
          )}
        </div>
      )}
      <div className="w-full mt-4.5 3md:mt-10">
        <div>
          <Collapsible
            hidden={pin.length === 0}
            title={() => (
              <>
                {pin.length > 0 && (
                  <div className="flex gap-4 items-center">
                    <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter flex gap-3">
                      <>{t('pinned')}</>
                      <AiFillPushpin className="text-2xl" />
                    </p>
                    {
                      isYourProfile && (
                        <Button
                        icon={<CgArrowsExchangeV className="text-sm"/>}
                        buttonName={t("reorderPinned")}
                        buttonRadius="6px"
                        iconPosition="left"
                        buttonClass="py-2 px-4 bg-gray"
                        buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                        onClick={() => customHandle()}
                        />
                      )
                    }
                    
                  </div>
                )}
              </>
            )}
            content={() => (
              <>
                {pin.map((obj, key) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  return (
                    <DetailedViewCard
                      containerStyle="mt-6"
                      key={`${key}`}
                      profile={profile}
                      featured={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || obj?.thumbnail?.url || null}
                      title={obj.title}
                      date={date}
                      people={obj.people}
                      position={obj[currentLang()] || obj.name}
                      positionDescription={obj.mp_description}
                      platform={obj.platform}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      category={obj?.category[currentLang()] || obj?.category?.name}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      onEdit={() => onEdit(obj, "pin")}
                      onDelete={() => onDelete(obj)}
                      isYourProfile={isYourProfile}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      location={obj.location}
                      positions={obj.positions}
                      mention_names={obj.mention_names}
                      isPinned={true}
                      categories={obj?.categories}
                      onShare={() => onShare(obj, "pin")}
                      share={true}
                      translateMilestone = {translateMilestone}
                      onCopyLink={() => onCopyLink(obj)}
                      setQuickEditId={()=>setQuickEditId(obj.id)}
                      quickEditId={quickEditId}
                      cancelEdit = {()=>{setQuickEditId(null)}}
                      userData={userData}
                      updateMilestonesState={updateMilestonesState}
                      milestoneEmbed={() => milestoneEmbed(obj)}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
      </div>

      <div className="w-full mt-4.5 3md:mt-10">
        {milestoneKeys?.map?.((key, mIndex) => (
          <div key={key} className="mt-10 mb-2">
            <Collapsible
              // openDefault={pin.length === 0 && mIndex === 0}
              showButtonBelow={true}
              footerTitle = {` ${t('hide')} ${findJobOrCat(key)?.label || key}`}
              title={() => (
                <>
                  <p className="organize-title px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
                    {/* {key} - {milestones[key].length} credits */}
                    {findJobOrCat(key)?.label || key} - {" "}
                    {findJobOrCat(key)?.count || milestones[key].length}
                    {/* {milestones[key].length} */}
                    {" "}
                    {t("credit", {count: findJobOrCat(key)?.count || milestones[key].length})}
                  </p>
                </>
              )}
              content={() => (
                <>
                  {milestones[key]?.map?.((obj) => {
                    const date = formatDate(obj, profile?.dateFormat,t);
                    const thumbnail = obj.thumbnail
                      ? obj.thumbnail.webp_url || obj.thumbnail.url
                      : null;
                    return (
                      <>
                        <DetailedViewCard
                          containerStyle="mt-6"
                          key={`${key}-${obj.id}`}
                          profile={profile}
                          featured={obj}
                          url={thumbnail}
                          viewUrl={thumbnail || obj?.thumbnail?.url || null}
                          title={obj.title}
                          date={date}
                          people={obj.people}
                          position={obj[currentLang()] ||  obj.name}
                          positionDescription={obj.mp_description}
                          platform={obj.platform}
                          description={obj.description}
                          privacy={obj.privacy}
                          isAdultContent={obj.is_adult_content ? true : false}
                          category={obj?.category[currentLang()] || obj?.category?.name}
                          buttons={obj.media_type}
                          onWatchMedia={onWatchMedia}
                          onViewImage={onViewImage}
                          onEdit={() => onEdit(obj)}
                          onDelete={() => onDelete(obj)}
                          isYourProfile={isYourProfile}
                          onReport={() => onReport({...obj, profile:milestone_owner})}
                          location={obj.location}
                          positions={obj.positions}
                          mention_names={obj.mention_names}
                          onShare={() => onShare(obj, "")}
                          share={true}
                          categories={obj?.categories}
                          translateMilestone = {translateMilestone}
                          onCopyLink={() => onCopyLink(obj)}
                          setQuickEditId={()=>setQuickEditId(obj.id)}
                          quickEditId={quickEditId}
                          cancelEdit = {()=>{setQuickEditId(null)}}
                          userData={userData}
                          updateMilestonesState={updateMilestonesState}
                          milestoneEmbed={() => milestoneEmbed(obj)}
                        />
                      </>
                    );
                  })}
                </>
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
